import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-home\"><path d=\"M39 3h6v13.017l-6-6.858v-6.159zm3 21l-18-20.568-18 20.568h-6l21-24h6l21 24h-6zm0 3.876v20.124h-12v-15c0-1.659-1.341-3-3-3h-6c-1.656 0-3 1.341-3 3v15h-12v-20.127l18-19.89 18 19.893z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol